import React from 'react';
import styles from '../css/notice.module.css'


const Notice = () => {


  return (
    <>
      <div id={styles.sub_top_warp}>
        <div className={styles.sub_top}>
          <p className={styles.sub_top_text01}>공지사항</p>
        </div>
      </div>

      <div id={styles.sub_con_warp}>

        <div className={styles.sub_title}>
          <p className={styles.sub_title_text01}>공지사항</p>
        </div>

        <table style={{ width: '100%', padding: 0, borderSpacing: 0 }}>
          <tr className={styles.table_title}>
            <td style={{ borderLeft: '1px solid #ccc' }}>번호</td>
            <td>제목</td>
            <td>작성자</td>
            <td>작성일</td>
          </tr>
          {/* <tr className="table_con">
            <td style={{ borderLeft: '1px solid #ccc' }}>145</td>
            <td><a href="catch_notice02.html">공지사항 테스트 제목입니다.</a></td>
            <td>CATCH</td>
            <td>2024.10.02</td>
          </tr>
          <tr className="table_con">
            <td style={{ borderLeft: '1px solid #ccc' }}>144</td>
            <td><a href="catch_notice02.html">공지사항 테스트 제목입니다.</a></td>
            <td>CATCH</td>
            <td>2024.10.02</td>
          </tr>
          <tr className="table_con">
            <td style={{ borderLeft: '1px solid #ccc' }}>143</td>
            <td><a href="catch_notice02.html">공지사항 테스트 제목입니다.</a></td>
            <td>CATCH</td>
            <td>2024.10.02</td>
          </tr>
          <tr className="table_con">
            <td style={{ borderLeft: '1px solid #ccc' }}>142</td>
            <td><a href="catch_notice02.html">공지사항 테스트 제목입니다.</a></td>
            <td>CATCH</td>
            <td>2024.10.02</td>
          </tr>
          <tr className="table_con">
            <td style={{ borderLeft: '1px solid #ccc' }}>141</td>
            <td><a href="catch_notice02.html">공지사항 테스트 제목입니다.</a></td>
            <td>CATCH</td>
            <td>2024.10.02</td>
          </tr>
          <tr className="table_con">
            <td style={{ borderLeft: '1px solid #ccc' }}>140</td>
            <td><a href="catch_notice02.html">공지사항 테스트 제목입니다.</a></td>
            <td>CATCH</td>
            <td>2024.10.02</td>
          </tr> */}
        </table>

        {/* <div className="sub31_num">
          <ul>
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>4</li>
            <li>5</li>
            <li>6</li>
            <li>7</li>
            <li>8</li>
            <li>9</li>
            <li>10</li>
          </ul>
        </div> */}
        <div style={{ clear: 'both', height: 80 }}></div>
      </div>

    </>
  );
}

export default Notice;
